import script from "./BotMessageHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./BotMessageHeader.vue?vue&type=script&setup=true&lang=ts"

import "./BotMessageHeader.vue?vue&type=style&index=0&id=47e53560&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47e53560"]])

export default __exports__